<ngx3js-renderer
    [alpha]="true"
    [controlType]="'orbit'"
    [controlOptions]="{
		enablePan: true,
		enableZoom: false
	}"
    #renderer3d
    (onRender)="onAnimate()"
    (mousemove)="onMouseMove($event)"
>
    <ngx3js-camera #camera>
        <ngx3js-position [x]="-50" [y]="0" [z]="-50"></ngx3js-position>
    </ngx3js-camera>

    <ngx3js-scene #scene>
        <!-- Luces -->
        <ngx3js-light
            [type]="'AmbientLight'"
            [color]="'0xffffff'"
            [intensity]="0.8"
        ></ngx3js-light>
        <ngx3js-light [type]="'DirectionalLight'" [intensity]="0.8">
            <ngx3js-position [x]="-3" [y]="10" [z]="-10"></ngx3js-position>
        </ngx3js-light>

        <!-- 🧊 Cubo transparente (contenedor) -->
        <ngx3js-mesh  #containerMesh>
            <ngx3js-geometry
                [type]="'box'"
                [width]="width"
                [height]="height * 1.05"
                [depth]="depth"
                [openEnded]="false"
            >
            </ngx3js-geometry>
            <ngx3js-material
                [type]="'meshphysical'"
                [color]="'#88ccee'"
                [transparent]="true"
                [opacity]="0.25"
                [metalness]="0.1"
                [roughness]="0"
                [reflectivity]="1"
                [clearcoat]="1"    
                [clearcoatRoughness]="0"
                [side]="'DoubleSide'"
            >
            </ngx3js-material>
        </ngx3js-mesh>

        <!-- 💧 Contenido interno (líquido o relleno) -->
        <ngx3js-mesh
            *ngFor="let liquid of liquids; let i = index"
            #liquidMeshes
            [renderOrder]="i"
        >
            <ngx3js-geometry
                [type]="'box'"
                [width]="width * 0.95"
                [height]="height * liquid.percentage"
                [depth]="depth * 0.95"
                [widthSegments]="getWidthSegments"
                [depthSegments]="getDepthSegments"
                [openEnded]="false"
            ></ngx3js-geometry>
            <ngx3js-material
                [type]="'meshstandard'"
                [color]="liquid.color"
                [transparent]="true"
                [opacity]="0.6"
                [depthWrite]="false"
                [depthTest]="false"
                [side]="'DoubleSide'"
            ></ngx3js-material>
            <ngx3js-position
                [x]="0"
                [y]="getLiquidPosition(i) + 0.001 * i"
                [z]="0"
            ></ngx3js-position>
        </ngx3js-mesh>
    </ngx3js-scene>
</ngx3js-renderer>

<!-- Tooltip -->
<div
    *ngIf="tooltipVisible"
    class="tooltip-container"
    [ngStyle]="{
        top: tooltipY + 'px',
        left: tooltipX + 'px'
    }"
>
    <!-- {{ tooltipText }} -->
    <ng-content select="[data-body]"></ng-content>
</div>
